module.exports = __webpack_public_path__ + "img/Cr(OH)3.5850d959.png";